import React from 'react';
import {InputNumber } from 'antd';

export default class extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div className='table-num-input'>
        <InputNumber {...this.props} />
      </div>
    )
  }
}
